/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../../../../src/app/components/client/shared/components/showdown.module';
import * as i2 from '@angular/common';
export const ShowdownModuleNgFactory:i0.NgModuleFactory<i1.ShowdownModule> = i0.ɵcmf(i1.ShowdownModule,
    ([] as any[]),(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,([] as any[])],[3,i0.ComponentFactoryResolver],i0.NgModuleRef]),i0.ɵmpd(4608,
          i2.NgLocalization,i2.NgLocaleLocalization,[i0.LOCALE_ID]),i0.ɵmpd(512,i2.CommonModule,
          i2.CommonModule,([] as any[])),i0.ɵmpd(512,i1.ShowdownModule,i1.ShowdownModule,
          ([] as any[]))]);
    });
const styles_ShowdownComponent:any[] = ['\n		showdown {\n            font-size: 1.4rem;\n            font-weight: 400;\n            line-height: 2.4rem;\n        }\n		showdown a {\n            text-decoration: none;\n        }\n		showdown a:hover {\n			text-decoration: underline;\n		}\n	'];
export const RenderType_ShowdownComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_ShowdownComponent,data:{}});
export function View_ShowdownComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(2,[i0.ɵqud(402653184,1,{showdownContainer:0}),(_l()(),i0.ɵeld(0,[[1,
      0],['showdownContainer',1]],(null as any),0,'div',([] as any[]),(null as any),
      (null as any),(null as any),(null as any),(null as any)))],(null as any),(null as any));
}
export function View_ShowdownComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'showdown',([] as any[]),
      (null as any),(null as any),(null as any),View_ShowdownComponent_0,RenderType_ShowdownComponent)),
      i0.ɵdid(4767744,(null as any),0,i1.ShowdownComponent,([] as any[]),(null as any),
          (null as any))],(null as any),(null as any));
}
export const ShowdownComponentNgFactory:i0.ComponentFactory<i1.ShowdownComponent> = i0.ɵccf('showdown',
    i1.ShowdownComponent,View_ShowdownComponent_Host_0,{text:'text'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2NsaWVudC9zaGFyZWQvY29tcG9uZW50cy9zaG93ZG93bi5tb2R1bGUubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9ub2RlL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvY2xpZW50L3NoYXJlZC9jb21wb25lbnRzL3Nob3dkb3duLm1vZHVsZS50cyIsIm5nOi8vL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2NsaWVudC9zaGFyZWQvY29tcG9uZW50cy9zaG93ZG93bi5tb2R1bGUudHMuU2hvd2Rvd25Db21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9jb21wb25lbnRzL2NsaWVudC9zaGFyZWQvY29tcG9uZW50cy9zaG93ZG93bi5tb2R1bGUudHMuU2hvd2Rvd25Db21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2ICNzaG93ZG93bkNvbnRhaW5lcj48L2Rpdj4iLCI8c2hvd2Rvd24+PC9zaG93ZG93bj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzsrRENBQTtNQUFBO01BQUE7OztvQkNBQTtNQUFBO2FBQUE7VUFBQTs7OyJ9



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./compiled/src/app/components/client/shared/components/showdown.module.ngfactory.ts